<template>
  <div style="width:100%">
    <AppForm label="配信ペースの設定">
      <v-radio-group
        v-model="inventoryType"
        :disabled="disabled"
        :value="type"
        row
        class="pt-2"
        hide-details
      >
        <v-radio
          v-for="typ in types"
          :key="typ.value"
          :label="typ.text"
          :value="typ.value"
          :disabled="typ.disabled"
        />
      </v-radio-group>
    </AppForm>
    <AppForm>
      <transition name="fade" mode="out-in">
        <div key="even" v-if="isEvenPace" style="width:100%; max-width:720px;">
          <h2 :style="valueStyle">{{ inventoryPercentage + ' %' }}</h2>
          <v-slider
            v-model="inventoryPercentage"
            :disabled="disabled"
            :min="50"
            :max="150"
            :tick-labels="ticksLabels"
            step="10"
            ticks="always"
            tick-size="2"
          />
          <v-fade-transition>
            <div v-if="warningForEvenPacePercentage" class="red--text">
              {{ warningForEvenPacePercentage }}
            </div>
          </v-fade-transition>
        </div>
        <v-layout key="notEven" v-else row align-center align-content-center>
          <v-text-field
            v-model.number="inventoryBudget"
            :rules="inventoryBudgetRules"
            @keydown.arrow-down.prevent
            @keydown.arrow-up.prevent
            @wheel.prevent
            prepend-icon="￥"
            label="一日予算上限"
            type="number"
            style="width:100%; max-width:210px;"
          />
          <span
            v-text="
              '設定によっては配信が早期終了もしくは、未達になる可能性があります'
            "
            style="color:red"
            class="ml-4"
          />
        </v-layout>
      </transition>
    </AppForm>
  </div>
</template>

<script>
import { BudgetPacingTypes } from '@/models/CampaignOperation'
const getTypeText = value => {
  switch (value) {
    case BudgetPacingTypes.EVEN_PACE:
      return '均等配信'
    case BudgetPacingTypes.DAILY_LIMIT:
      return '一日予算上限'
    default:
      return ''
  }
}

export default {
  props: {
    type: {
      type: String,
      default: BudgetPacingTypes.EVEN_PACE,
    },
    percentage: {
      type: Number,
      default: 110,
    },
    budget: {
      type: Number,
      default: 10000,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ticksLabels: ['50%', '', '', '', '', '100%', '', '', '', '', '150%'],
      inventoryBudgetRules: [
        v => Boolean(v !== undefined && v !== '') || '入力して下さい',
        v => Number.isInteger(Number(v)) || '整数で入力して下さい',
        v => Number(v) > 0 || '0より上の数値を入力して下さい',
      ],
    }
  },
  computed: {
    types() {
      return Object.keys(BudgetPacingTypes).map(type => {
        const value = BudgetPacingTypes[type]
        let disabled = false
        return { value, text: getTypeText(value), disabled: disabled }
      })
    },
    isEvenPace() {
      return this.inventoryType === BudgetPacingTypes.EVEN_PACE
    },
    valueStyle() {
      return this.inventoryPercentage === 150
        ? 'text-align:right'
        : 'padding-left: calc(' + (this.inventoryPercentage - 50) + '% - 20px)'
    },
    inventoryType: {
      get() {
        return this.type
      },
      set(value) {
        this.$emit('setType', value)
      },
    },
    inventoryPercentage: {
      get() {
        return this.percentage
      },
      set(value) {
        this.$emit('setPercentage', value)
      },
    },
    inventoryBudget: {
      get() {
        return this.budget
      },
      set(value) {
        this.$emit('setBudget', value)
      },
    },
    warningForEvenPacePercentage() {
      return this.inventoryPercentage < 100
        ? '消化未達ペースとなります。100%以上に設定することを推奨します。'
        : undefined
    },
  },
}
</script>

<style>
.mention {
  color: #aaa;
  padding-top: 5px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
